import * as FileSaver from 'file-saver'
import {
	collection,
	onSnapshot,
	query,
	getDoc,
	getDocs,
	doc,
} from 'firebase/firestore'
import { useNavigate } from 'react-router-dom'
import React, { forwardRef, useEffect, useState } from 'react'
import { auth } from '../../firebase'
import DatePicker from 'react-datepicker'
import { Link } from 'react-router-dom'
import XLSX from 'sheetjs-style'
import fr from 'date-fns/locale/fr'
import Snackbar from '@mui/material/Snackbar'
import Alert from '@mui/material/Alert'
import Button from '@mui/material/Button'
import Dialog from '@mui/material/Dialog'
import DialogActions from '@mui/material/DialogActions'
import DialogContent from '@mui/material/DialogContent'
import DialogContentText from '@mui/material/DialogContentText'
import DialogTitle from '@mui/material/DialogTitle'
import MenuItem from '@mui/material/MenuItem'
import Select from '@mui/material/Select'
import TextField from '@mui/material/TextField'
import { subMonths } from 'date-fns'

import 'react-datepicker/dist/react-datepicker.css'
import { ArrowBottom, ArrowRight } from '../../components/Icon'
import { db } from '../../firebase'
import DashboardHeader from './DashboardHeader'

import saveCustomer from '../../utility/saveCustomer'
import deleteCustomer from '../../utility/deleteCustomer'
import LoadingSpinner from '../../components/LoadingSpinner'
import axios from 'axios'
import ENV from '../../env'

const Dashboard = () => {
	const navigate = useNavigate()
	const [snapShot, setSnapShot] = useState(null)
	const [customers, setCustomers] = useState([])
	const [sellers, setSellers] = useState([])
	const [password, setPassword] = useState('')
	const [authenticated, setAuthenticated] = useState(false)
	const [startDate, setStartDate] = useState(subMonths(new Date(), 6))
	const [endDate, setEndDate] = useState(new Date())
	const [isAlert, setIsAlert] = useState(false)
	const [alertMessage, setAlertMessage] = useState('')
	const [alertSeverity, setAlertSeverity] = useState('info')
	const [showDelete, setShowDelete] = useState(false)
	const [selectedCustomer, setSelectedCustomer] = useState()
	const [showrooms, setShowrooms] = useState([])
	const [selectedShowroom, setSelectedShowroom] = useState(false)

	// --- START PAGINATION STATE ---
	const [currentPage, setCurrentPage] = useState(1)
	const [itemsPerPage] = useState(20)
	const [paginatedCustomers, setPaginatedCustomers] = useState([])
	// --- END PAGINATION STATE ---

	const [filterNotInVtiger, setFilterNotInVtiger] = useState(false)
	const [isSearching, setIsSearching] = useState(true)

	const [isCrmLoading, setIsCrmLoading] = useState({}) // Track loading state per customer

	const handleClose = () => {
		setIsAlert(false)
		setAlertMessage('')
		setAlertSeverity('info')
	}

	const handleOpenDelete = (customerId) => {
		setSelectedCustomer(customerId)
		setShowDelete(true)
	}

	const handleCloseDelete = () => {
		setShowDelete(false)
		setSelectedCustomer()
	}

	const ExampleCustomInput = forwardRef(({ value, onClick }, ref) => (
		<button className="export-button" onClick={onClick} ref={ref}>
			{value || 'Select Date'}
		</button>
	))

	useEffect(() => {
		const unsubscribe = auth.onAuthStateChanged(async (user) => {
			if (user) {
				// User is authenticated, allow access to protected routes
				console.log('User is authenticated')
				const uid = user.uid

				// Check if document with ID equal to uid exists in the "Store" collection
				const storeRef = doc(collection(db, 'Users'), uid)

				try {
					const docSnapshot = await getDoc(storeRef)
					console.log('docSnapshot')

					if (docSnapshot.exists()) {
						// Document with ID equal to uid exists, navigate to login
						console.log('Is sales')
						// navigate("/login");
					} else {
						console.log('Is admin')
					}
				} catch (error) {
					// Handle any errors that occurred while fetching the document
					console.error('Error getting document:', error)
				}
			} else {
				// User is not authenticated, redirect to login page
				navigate('/login')
			}
		})

		return () => unsubscribe()
	}, [navigate])

	const fileType =
		'application/vnd.openxmlformats-officedocument.spreadseetml.sheet;charset=UTF-8'
	const fileExtension = '.xlsx'

	const exportToExcel = async (e) => {
		e.preventDefault()
		// Exports ALL filtered customers, not just the current page
		const ws = XLSX.utils.json_to_sheet(customers)
		const wb = { Sheets: { data: ws }, SheetNames: ['data'] }
		const excelBuffer = XLSX.write(wb, { bookType: 'xlsx', type: 'array' })
		const data = new Blob([excelBuffer], { type: fileType })
		FileSaver.saveAs(data, 'clients' + fileExtension)
	}

	// Helper function to get the month index
	function getMonthIndex(monthString) {
		const months = [
			'janvier',
			'février',
			'mars',
			'avril',
			'mai',
			'juin',
			'juillet',
			'août',
			'septembre',
			'octobre',
			'novembre',
			'décembre',
		]
		return months.findIndex(
			(month) => month.toLowerCase() === monthString.toLowerCase(),
		)
	}

	// Initial data fetch (fetches ALL records)
	useEffect(() => {
		setIsAlert(true)
		setAlertMessage('Chargement...')
		setAlertSeverity('info')
		const q = query(collection(db, 'Customers'))

		const unsuscribe = onSnapshot(q, (querySnapshot) => {
			setSnapShot(querySnapshot)
		})
		return () => {
			unsuscribe()
		}
	}, [])

	// Filtering logic
	// Filtering logic
	useEffect(() => {
		if (snapShot) {
			let records = []
			let newArray = []

			snapShot.docs.forEach((doc) => {
				let dateString = doc.data().createdAt
				// Handle different date formats (Firestore Timestamp, string, etc.)
				if (typeof dateString !== 'string') {
					if (dateString && dateString.toDate) {
						// Firestore Timestamp
						dateString = dateString.toDate().toLocaleDateString('fr-FR', { day: 'numeric', month: 'long', year: 'numeric' })
					} else {
						console.warn('Invalid date format for createdAt:', dateString)
						return // Skip this record
					}
				}
				const dateParts = dateString.split(' ')
				const day = parseInt(dateParts[0])
				const month = getMonthIndex(dateParts[1])
				const year = parseInt(dateParts[2])

				const recordDate = new Date(year, month, day)

				// Compare only the date parts (year, month, day)
				const recordDateOnly = new Date(
					recordDate.getFullYear(),
					recordDate.getMonth(),
					recordDate.getDate(),
				)
				const startDateOnly = new Date(
					startDate.getFullYear(),
					startDate.getMonth(),
					startDate.getDate(),
				)
				const endDateOnly = new Date(
					endDate.getFullYear(),
					endDate.getMonth(),
					endDate.getDate(),
				)

				const isDateInRange =
					startDateOnly <= recordDateOnly && recordDateOnly <= endDateOnly
				const isShowroomSelected =
					!selectedShowroom || doc.data().showroom === selectedShowroom

				if (isDateInRange && isShowroomSelected) {
					records.push({
						...doc.data(),
						id: doc.id,
						parsedDate: recordDate, // Store the parsed date for sorting
					})

					const sellerIndex = newArray.findIndex(
						(item) => item.name === doc.data().vendeur,
					)

					if (sellerIndex >= 0) {
						newArray[sellerIndex] = {
							name: doc.data().vendeur,
							quantity: parseInt(newArray[sellerIndex].quantity + 1),
						}
					} else {
						newArray.push({
							name: doc.data().vendeur,
							quantity: 1,
						})
					}
				}
			})

			// Sort by date descending (latest first)
			records.sort((a, b) => b.parsedDate - a.parsedDate)

			setCustomers(records)
			setSellers(newArray)

			setIsAlert(false)
			setAlertMessage('')
			setAlertSeverity('info')
		}
	}, [snapShot, startDate, endDate, selectedShowroom])

	// Reset page only when filter criteria change (not when data refreshes after save)
	useEffect(() => {
		setIsSearching(true)
		setCurrentPage(1)
	}, [startDate, endDate, selectedShowroom, filterNotInVtiger])

	// --- START PAGINATION LOGIC ---
	useEffect(() => {
		const filtered = filterNotInVtiger
			? customers.filter((c) => !c.contactId || c.contactId === 'none')
			: customers
		const startIndex = (currentPage - 1) * itemsPerPage
		const endIndex = startIndex + itemsPerPage
		setPaginatedCustomers(filtered.slice(startIndex, endIndex))
		if (snapShot) {
			setIsSearching(false)
		}
	}, [customers, currentPage, itemsPerPage, filterNotInVtiger, snapShot])

	const filteredCount = filterNotInVtiger
		? customers.filter((c) => !c.contactId || c.contactId === 'none').length
		: customers.length
	const totalPages = Math.ceil(filteredCount / itemsPerPage)

	const handlePageChange = (newPage) => {
		if (newPage >= 1 && newPage <= totalPages) {
			setCurrentPage(newPage)
		}
	}
	// --- END PAGINATION LOGIC ---

	const fetchShowrooms = async () => {
		try {
			const q = query(collection(db, 'Showrooms'))
			let showroomsData = []

			const querySnapshot = await getDocs(q)
			if (querySnapshot.empty) {
				console.log('No documents found')
			} else {
				querySnapshot.forEach((doc) => {
					showroomsData.push({
						name: doc.data().name,
						id: doc.id,
					})
				})
				setShowrooms(showroomsData)
			}
			console.log('Doc found')
		} catch (error) {
			console.error('Error fetching showrooms:', error)
		}
	}

	useEffect(() => {
		fetchShowrooms()
	}, [])

	const [sales, setSales] = useState([
		{
			label: 'Vendeur',
			value: false,
		},
	])
	const [salesUsers, setSalesUsers] = useState([]) // State to store the full user list including emails

	const getSales = async () => {
		try {
			console.log('📋 Récupération de la liste des vendeurs via API...')
			const user = auth.currentUser
			if (!user) {
				console.error('❌ Utilisateur non authentifié')
				return
			}

			const token = await user.getIdToken()
			const response = await fetch(
				`${ENV.firebaseApiUrl}/user/list`,
				{
					method: 'GET',
					headers: {
						'Content-Type': 'application/json',
						'Authorization': `Bearer ${token}`,
					},
				}
			)

			if (!response.ok) {
				throw new Error(`HTTP error! status: ${response.status}`)
			}

			const salesData = await response.json()
			console.log('✅ Vendeurs chargés:', salesData.length, 'utilisateurs')

			const formattedSalesData = salesData.map((user) => ({
				label: user.username,
				value: user.username,
				email: user.email,
			}))

			// Store the list with emails for later lookup
			setSalesUsers(formattedSalesData)

			setSales([
				{
					label: 'Vendeur',
					value: false,
				},
				...formattedSalesData,
			])
		} catch (error) {
			console.error('Error fetching sales:', error)
		}
	}

	useEffect(() => {
		getSales()
	}, [])

	const updateRecordHandler = async (updatedRecord) => {
		console.log('Updating record:', updatedRecord)

		setAlertMessage('Sauvegarde...')
		setIsAlert(true)
		setAlertSeverity('info')

		try {
			// Remove parsedDate before saving (it's only for local sorting)
			const { parsedDate, ...customerToSave } = updatedRecord

			// Call saveCustomer with the complete customer object (including id)
			await saveCustomer(customerToSave)

			console.log('Customer update successful')
			setAlertSeverity('success')
			setAlertMessage('Sauvegarde réussie.')
			setIsAlert(true)
		} catch (error) {
			console.log('Customer update failed:', error)
			setAlertSeverity('error')
			setAlertMessage(`Sauvegarde échouée: ${error.message}`)
			setIsAlert(true)
		}
	}

	const createLeadInCrm = async (customerData) => {
		const customerId = customerData.id
		const {
			mail,
			name,
			firstName,
			phoneNumber,
			postalCode,
			title,
			note,
			project,
			guess,
			date,
			action,
			stat,
			type,
			showroom,
			vendeur,
		} = customerData

		// Set loading state for this specific customer
		setIsCrmLoading((prev) => ({ ...prev, [customerId]: true }))
		setAlertMessage(`Création du lead CRM pour ${name}...`)
		setIsAlert(true)
		setAlertSeverity('info')

		let crmContactId = 'none'
		let crmDealId = 'none'

		// You'll need to get the vendeur email - adjust based on your data structure
		let crmVendeurEmail = 'it@couleurcuisine.be' // Default fallback

		if (vendeur) {
			const selectedSale = salesUsers.find((user) => user.label === vendeur)
			if (selectedSale && selectedSale.email) {
				crmVendeurEmail = selectedSale.email

				if (selectedSale.email === 'hello@monastudio.co') {
					crmVendeurEmail = 'it@couleurcuisine.be'
				}
			}
		}

		// Helper to format date for API
		const formatDateForAPI = (dateStr) => {
			if (!dateStr) return new Date().toISOString()

			const months = {
				janvier: 0,
				février: 1,
				mars: 2,
				avril: 3,
				mai: 4,
				juin: 5,
				juillet: 6,
				août: 7,
				septembre: 8,
				octobre: 9,
				novembre: 10,
				décembre: 11,
			}

			const parts = dateStr.split(' ')
			if (parts.length >= 3) {
				const day = parseInt(parts[0])
				const month = months[parts[1].toLowerCase()]
				const year = parseInt(parts[2])

				if (day && month !== undefined && year) {
					return new Date(year, month, day).toISOString()
				}
			}

			return new Date().toISOString()
		}

		try {
			// 1. Make CRM API call
			const crmPayload = {
				createdAt: new Date().toISOString().replace('Z', ''),
				vendeur: crmVendeurEmail,
				showroom: showroom === 'TEST' ? 'test rémi' : showroom,
				mail: mail || '',
				name: name || '',
				firstName: firstName || '',
				phoneNumber: phoneNumber || '',
				postalCode: postalCode || '',
				title: title || 'Autres',
				note: note || 'Créé depuis le Dashboard',
				project: project || 'Autre',
				guess: guess || '',
				date: formatDateForAPI(date),
				action: action || 'Call',
				stat: stat || 'B',
				type: type || '',
				id: customerId,
			}

			console.log('Sending CRM payload:', crmPayload)

			const crmResponse = await axios.post(
				`${process.env.REACT_APP_API_BASE_URL}/monastudio/v1/lead`,
				crmPayload,
				{
					headers: {
						'x-API-Key': `${process.env.REACT_APP_CRM_API_KEY}`,
						'Content-Type': 'application/json',
					},
				},
			)

			// 2. Extract CRM IDs from response
			crmContactId = crmResponse.data.contact_id
			crmDealId = crmResponse.data.deal_id

			console.log('CRM IDs retrieved:', { crmContactId, crmDealId })

			// 3. Update customer in Firebase
			try {
				// Create updated customer object with CRM IDs
				const { parsedDate, ...customerWithoutParsedDate } = customerData
				const updatedCustomer = {
					...customerWithoutParsedDate,
					contactId: crmContactId,
					dealId: crmDealId,
				}

				console.log('Saving to Firebase:', updatedCustomer)
				await saveCustomer(updatedCustomer)

				console.log('Firebase update successful')
			} catch (firebaseError) {
				console.error('Firebase update error:', firebaseError)
				throw new Error(`Firebase update failed: ${firebaseError.message}`)
			}

			// 4. Update local state immediately
			setCustomers((prevCustomers) =>
				prevCustomers.map((c) =>
					c.id === customerId
						? { ...c, contactId: crmContactId, dealId: crmDealId }
						: c,
				),
			)

			setAlertSeverity('success')
			setAlertMessage(
				`Lead créé! Contact ID: ${crmContactId}, Deal ID: ${crmDealId}`,
			)
			setIsAlert(true)
		} catch (error) {
			console.error("Erreur lors de l'ajout dans le CRM:", error)

			let errorMessages = ''
			if (error.response) {
				console.error('Error Response Data:', error.response.data)
				console.error('Error Response Status:', error.response.status)

				if (
					error.response.data?.detail &&
					Array.isArray(error.response.data.detail)
				) {
					errorMessages = error.response.data.detail
						.map((err, index) => {
							const field = err.loc ? err.loc.join(' > ') : 'Unknown field'
							return `${index + 1}. ${field}: ${err.msg}`
						})
						.join('\n')
				} else if (error.response.data?.detail) {
					errorMessages =
						typeof error.response.data.detail === 'string'
							? error.response.data.detail
							: JSON.stringify(error.response.data.detail, null, 2)
				} else {
					errorMessages = JSON.stringify(error.response.data, null, 2)
				}

				setAlertSeverity('error')
				setAlertMessage(`Erreur CRM: ${errorMessages}`)
			} else if (error.request) {
				setAlertSeverity('error')
				setAlertMessage(
					"Erreur lors de l'ajout dans le CRM: Aucune réponse du serveur",
				)
			} else {
				setAlertSeverity('error')
				setAlertMessage(`Erreur lors de l'ajout dans le CRM: ${error.message}`)
			}
			setIsAlert(true)
		} finally {
			setIsCrmLoading((prev) => ({ ...prev, [customerId]: false }))
		}
	}

	const deleteRecordHandler = async () => {
		console.log(selectedCustomer)

		setShowDelete(false)
		setAlertMessage('Suppression...')
		setIsAlert(true)
		try {
			await deleteCustomer(selectedCustomer)

			setAlertSeverity('success')
			setAlertMessage('Suppression réussie.')
			setIsAlert(true)

			// The update of the 'customers' array below will trigger the pagination effect
			setCustomers(
				customers.filter((customer) => customer.id !== selectedCustomer),
			)
			setSelectedCustomer()
		} catch (error) {
			console.log('Customer update failed: ' + error)
			setAlertSeverity('error')
			setAlertMessage('Suppression échouée.')
			setIsAlert(true)
			setSelectedCustomer()
		}
	}

	return (
		<>
			<DashboardHeader />
			<div
				className="container"
				style={{ '--title:': '#111928', fontFamily: 'var(--inter)' }}
			>
				<div className="dashboard-body">
					{/* ── FILTER BAR ── */}
					<div className="dashboard-filter-bar">
						<div className="dashboard-filter-bar__title">
							<span className="dashboard-filter-bar__label">
								{selectedShowroom || 'Tous les salons'}
							</span>
							<span className="dashboard-filter-bar__count">
								{filteredCount} résultat{filteredCount !== 1 ? 's' : ''}
								{filterNotInVtiger ? ' · non encodés Vtiger' : ''}
							</span>
						</div>
						<div className="dashboard-filter-bar__controls">
							<div className="dashboard-filter-group">
								<label className="dashboard-filter-group__label">Salon</label>
								<Select
									value={selectedShowroom}
									onChange={(e) => setSelectedShowroom(e.target.value)}
									size="small"
									MenuProps={{ disablePortal: true }}
									sx={{
										minWidth: 160,
										background: '#fff',
										borderRadius: '6px',
									}}
								>
									<MenuItem value={false}>Tous</MenuItem>
									{showrooms.map((showroom) => (
										<MenuItem key={showroom.id} value={showroom.name}>
											{showroom.name}
										</MenuItem>
									))}
								</Select>
							</div>
							<div className="dashboard-filter-group">
								<label className="dashboard-filter-group__label">Du</label>
								<DatePicker
									selected={startDate}
									onChange={(date) => setStartDate(date)}
									selectsStart
									startDate={startDate}
									endDate={endDate}
									customInput={<ExampleCustomInput />}
									locale={fr}
									dateFormat="dd/MM/yyyy"
								/>
							</div>
							<div className="dashboard-filter-group">
								<label className="dashboard-filter-group__label">Au</label>
								<DatePicker
									selected={endDate}
									onChange={(date) => setEndDate(date)}
									selectsEnd
									startDate={startDate}
									endDate={endDate}
									minDate={startDate}
									customInput={<ExampleCustomInput />}
									locale={fr}
									dateFormat="dd/MM/yyyy"
								/>
							</div>
							<label className="dashboard-vtiger-toggle">
								<input
									type="checkbox"
									checked={filterNotInVtiger}
									onChange={(e) => setFilterNotInVtiger(e.target.checked)}
								/>
								<span>Non encodés Vtiger</span>
							</label>
							<form onSubmit={exportToExcel} style={{ marginLeft: 'auto' }}>
								<button type="submit" className="export-button">
									↓ Exporter XLSX
								</button>
							</form>
						</div>
					</div>
					<div className="__table-container">
						{isSearching && (
							<div className="dashboard-search-loading">
								<LoadingSpinner height="110px" width="110px" />
								<span>Recherche des leads...</span>
							</div>
						)}
						<div className="__table-container-inner">
							<div className="table-responsive">
								<table className="table __table">
									<thead>
										<tr>
											<th>Vendeur / Note</th>
											<th>Type</th>
											<th>Salon</th>
											<th>Nom</th>
											<th>Prénom</th>
											<th>Email</th>
											<th>Tél</th>
											<th>Projet</th>
											<th>Action</th>
											<th>Stat</th>
											<th>Concours</th>
											<th>CRM</th>
											<th>Contact ID</th>
											<th>Deal ID</th>
											<th></th>
											<th></th>
										</tr>
									</thead>
									<tbody>
										{paginatedCustomers?.map((customer, i) => {
											const {
												vendeur,
												note,
												name,
												firstName,
												mail,
												phoneNumber,
												stat,
												project,
												action,
												type,
												guess,
												showroom,
												contactId,
												dealId,
											} = customer

											const inCrm = contactId && contactId !== 'none'

											return (
												<tr
													key={customer.id}
													className={inCrm ? '' : 'row--pending'}
												>
													<td>
														<div className="cell-vendeur">
															<span className="cell-vendeur__name">
																{vendeur}
															</span>
															{note && (
																<span
																	className="cell-vendeur__note"
																	title={note}
																>
																	{note}
																</span>
															)}
														</div>
													</td>
													<td>
														<span className="cell-tag">{type}</span>
													</td>
													<td>
														<span className="cell-muted">{showroom}</span>
													</td>
													<td>
														<TextField
															type="text"
															value={name}
															size="small"
															sx={{ width: '120px' }}
															onChange={(e) =>
																setCustomers((prev) =>
																	prev.map((c) =>
																		c.id === customer.id
																			? { ...c, name: e.target.value }
																			: c,
																	),
																)
															}
														/>
													</td>
													<td>
														<TextField
															type="text"
															value={firstName}
															size="small"
															sx={{ width: '120px' }}
															onChange={(e) =>
																setCustomers((prev) =>
																	prev.map((c) =>
																		c.id === customer.id
																			? { ...c, firstName: e.target.value }
																			: c,
																	),
																)
															}
														/>
													</td>
													<td>
														<TextField
															type="email"
															value={mail}
															size="small"
															sx={{ width: '170px' }}
															onChange={(e) =>
																setCustomers((prev) =>
																	prev.map((c) =>
																		c.id === customer.id
																			? { ...c, mail: e.target.value }
																			: c,
																	),
																)
															}
														/>
													</td>
													<td>
														<TextField
															type="tel"
															value={phoneNumber}
															size="small"
															sx={{ width: '120px' }}
															onChange={(e) =>
																setCustomers((prev) =>
																	prev.map((c) =>
																		c.id === customer.id
																			? { ...c, phoneNumber: e.target.value }
																			: c,
																	),
																)
															}
														/>
													</td>
													<td>
														<select
															className="table-select"
															value={project}
															onChange={(e) =>
																setCustomers((prev) =>
																	prev.map((c) =>
																		c.id === customer.id
																			? { ...c, project: e.target.value }
																			: c,
																	),
																)
															}
														>
															{selectData.map((option) => (
																<option key={option.value} value={option.value}>
																	{option.label}
																</option>
															))}
														</select>
													</td>
													<td>
														<select
															className="table-select"
															value={action}
															onChange={(e) =>
																setCustomers((prev) =>
																	prev.map((c) =>
																		c.id === customer.id
																			? { ...c, action: e.target.value }
																			: c,
																	),
																)
															}
														>
															{actionData.map((option) => (
																<option key={option.value} value={option.value}>
																	{option.label}
																</option>
															))}
														</select>
													</td>
													<td>
														<select
															className="table-select"
															value={stat}
															onChange={(e) =>
																setCustomers((prev) =>
																	prev.map((c) =>
																		c.id === customer.id
																			? { ...c, stat: e.target.value }
																			: c,
																	),
																)
															}
														>
															{statData.map((option) => (
																<option key={option.value} value={option.value}>
																	{option.label}
																</option>
															))}
														</select>
													</td>
													<td>
														<span className="cell-muted">{guess}</span>
													</td>
													<td>
														{!inCrm ? (
															<Button
																onClick={() => createLeadInCrm(customer)}
																variant="contained"
																color="primary"
																size="small"
																disabled={isCrmLoading[customer.id]}
																sx={{
																	whiteSpace: 'nowrap',
																	fontSize: '0.72rem',
																}}
															>
																{isCrmLoading[customer.id]
																	? '...'
																	: 'Créer lead'}
															</Button>
														) : (
															<span
																className="crm-badge crm-badge--ok"
																title={`Contact: ${contactId} / Deal: ${dealId}`}
															>
																✓ CRM
															</span>
														)}
													</td>
													<td>
														<span className="cell-muted" style={{ fontSize: '0.75rem' }}>
															{contactId && contactId !== 'none' ? contactId : '—'}
														</span>
													</td>
													<td>
														<span className="cell-muted" style={{ fontSize: '0.75rem' }}>
															{dealId && dealId !== 'none' ? dealId : '—'}
														</span>
													</td>
													<td>
														<Button
															onClick={() => updateRecordHandler(customer)}
															variant="outlined"
															color="success"
															size="small"
														>
															Sauver
														</Button>
													</td>
													<td>
														<Button
															onClick={() => handleOpenDelete(customer.id)}
															variant="outlined"
															color="error"
															size="small"
														>
															✕
														</Button>
													</td>
												</tr>
											)
										})}
									</tbody>
								</table>
							</div>
							{/* ── PAGINATION ── */}
							<div className="dashboard-pagination">
								<Button
									onClick={() => handlePageChange(currentPage - 1)}
									disabled={currentPage === 1}
									variant="outlined"
									size="small"
								>
									← Précédent
								</Button>
								<span className="dashboard-pagination__info">
									Page{' '}
									<input
										className="dashboard-pagination__input"
										type="number"
										min={1}
										max={totalPages || 1}
										value={currentPage}
										onChange={(e) => {
											const val = parseInt(e.target.value)
											if (val >= 1 && val <= totalPages) setCurrentPage(val)
										}}
									/>{' '}
									/ {totalPages || 1}
								</span>
								<Button
									onClick={() => handlePageChange(currentPage + 1)}
									disabled={currentPage === totalPages || filteredCount === 0}
									variant="outlined"
									size="small"
								>
									Suivant →
								</Button>
							</div>
						</div>
					</div>

					<Snackbar
						open={isAlert}
						autoHideDuration={2000}
						onClose={handleClose}
					>
						<Alert
							onClose={handleClose}
							severity={alertSeverity}
							sx={{ width: '100%' }}
						>
							{alertMessage}
						</Alert>
					</Snackbar>

					<Dialog
						open={showDelete}
						onClose={handleCloseDelete}
						aria-labelledby="alert-dialog-title"
						aria-describedby="alert-dialog-description"
					>
						<DialogTitle id="alert-dialog-title">
							Supprimer cet enregistrement ?
						</DialogTitle>
						<DialogContent>
							<DialogContentText id="alert-dialog-description">
								Êtes-vous sûr de vouloir supprimer cet enregistrement ?
								L'opération est irréversible.
							</DialogContentText>
						</DialogContent>
						<DialogActions>
							<Button onClick={handleCloseDelete}>Annuler</Button>
							<Button onClick={deleteRecordHandler} color="error" autoFocus>
								Confirmer
							</Button>
						</DialogActions>
					</Dialog>
				</div>
			</div>
		</>
	)
}

const selectData = [
	{
		label: 'Neuf',
		value: 'Neuf',
	},
	{
		label: 'Rénovation',
		value: 'Rénovation',
	},
	{
		label: 'Immobilier',
		value: 'Immobilier',
	},
	{
		label: 'Inactif',
		value: 'Inactif',
	},
	{
		label: 'Autre',
		value: 'Autre',
	},
]

const actionData = [
	{
		label: 'RDV',
		value: 'RDV',
	},
	{
		label: 'Call',
		value: 'Call',
	},
]

const statData = [
	{
		label: 'A',
		value: 'A',
	},
	{
		label: 'B',
		value: 'B',
	},
	{
		label: 'C',
		value: 'C',
	},
	{
		label: 'D',
		value: 'D',
	},
]

export default Dashboard
